import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'so0007',
    ecrans: ['00-2'],
    params: ['id',
             '?demcleint']
});
